import state from './state'

export default {
    getCompany:    () => state.company || null,
}